import { usePageContext, createPortal } from '@remax/runtime';
export default function Modal(_a) {
    var children = _a.children;
    // context 一定存在
    var ctx = usePageContext();
    return createPortal(children, ctx.modalContainer);
}
